<template>
	<transition name="slide">
		<div class="menu-wrapper corlo" :class="{ collapsed: msg }">
			<el-menu :default-active="activePath" :collapse="msg" router :collapse-transition="false">
				<Nav v-for="item in items" :key="item.url" :msg="msg" :item="item"></Nav>
			</el-menu>
		</div>
	</transition>
</template>

<script>
import Nav from "./Nav.vue";

export default {
	data () {
		return {
			activePath: this.$route.path,
			items: [{
				name: "首页",
				url: "/Home",
				icon: "el-icon-s-home",
			},
			{
				name: "房态管理",
				url: "/RoomStatus",
				icon: "el-icon-bank-card",
			},
			{
				name: "活动管理",
				url: "/Activities",
				icon: "el-icon-info",
				children: [{
					name: "活动管理",
					url: "/Activities/management",
				},
				{
					name: "优惠券种类",
					url: "/Activities/kinds",
				},
				{
					name: "优惠券",
					url: "/Activities/coupon",
				},
				],
			},
			{
				name: "用户管理",
				url: "/User",
				icon: "el-icon-s-custom",
				children: [{
					name: "用户管理",
					url: "/User/user",
				},
				{
					name: "报修管理",
					url: "/User/repair",
				},
				],
			},
			{
				name: "合同管理",
				url: "/Contract",
				icon: "el-icon-document-remove",
				children: [{
					name: "合同管理",
					url: "/Contract/contract",
				},
				{
					name: "续租管理",
					url: "/Contract/renew",
				},
				{
					name: "退租管理",
					url: "/Contract/surrender",
				},
				],
			},
			{
				name: "账单管理",
				url: "/Bills",
				icon: "el-icon-document",
				children: [{
					name: "账单管理",
					url: "/Bills/bills",
				},
				{
					name: "房租管理",
					url: "/Bills/orders",
				},
				],
			},
			{
				name: "设备管理",
				url: "/Device",
				icon: "el-icon-coordinate",
				children: [{
					name: "智能水表",
					url: "/Intelligent_devices/water_meter",
					icon: "el-icon-heavy-rain",
				},
				{
					name: "智能电表",
					url: "/Intelligent_devices/electricity_meter",
					icon: "el-icon-lightning",
				}, {
					name: "大门门禁",
					icon: "el-icon-house",
					url: "/Gate",
					children: [{
						name: "设备列表",
						url: "/Device/access/devicelist",
					},
					{
						name: "人员列表",
						url: "/Device/access/accessuser",
					},
					{
						name: "进出记录",
						url: "/User/entry",
					},
					],
				},
				// {
				// 	name: "水表管理",
				// 	icon: "el-icon-heavy-rain",
				// 	url: "/Device/hydropower/Watermetermanagement",
				// },
				// {
				// 	name: "电表管理",
				// 	icon: "el-icon-lightning",
				// 	url: "/Device/hydropower/Metermanagement",
				// },
				{
					name: "门锁管理",
					icon: "el-icon-lock",
					url: "/Lock",
				},
				],
			},

			{
				name: "房源管理",
				url: "/Listings",
				icon: "el-icon-office-building",
				children: [{
					name: "房间管理",
					url: "/Listings/room",
				},
				{
					name: "密码修改记录",
					url: "/Listings/password",
				},
				],
			},
			{
				name: "系统管理",
				url: "/System",
				icon: "el-icon-setting",
				children: [{
					name: "系统参数",
					url: "/System/parameters",
				},
				{
					name: "管理员账号管理",
					url: "/System/administrator",
				},
				{
					name: "条款",
					url: "/System/terms",
				},
				{
					name: "小程序轮播图",
					url: "/System/carousel",
				}, {
					name: "操作日志",
					url: "/System/operation_log",
				}, {
					name: "系统日记",
					url: "/System/loglist",
				},
				],
			},
			],
			gap: false,
		};
	},
	props: ["msg"],
	watch: {
		'$route' (to, from) {
			this.activePath = to.path;

		}
	},
	components: {
		Nav,
	}
};
</script>

<style scoped>
.corlo {
	background-color: #fff;
	height: 94vh;
	width: 100%;
	overflow: auto;
	overflow-x: hidden;
	white-space: nowrap;
}

.corlo::-webkit-scrollbar {
	width: 4px;
	height: 4px;
}

.corlo::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.corlo::-webkit-scrollbar-track {
	border-radius: 0;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.1);
}

/* 调整折叠状态下弹出菜单的样式 */
.el-menu--popup {
	min-width: 150px;
	/* 设置最小宽度 */
	background-color: #fff;
	/* 设置背景颜色 */
	border: 1px solid #e6e6e6;
	/* 设置边框 */
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	/* 添加阴影 */
}

.el-menu--popup .el-menu-item {
	padding: 0 20px;
	/* 设置内边距 */
	white-space: nowrap;
	/* 防止文字换行 */
}

.el-menu--popup .el-menu-item:hover {
	background-color: #ecf5ff;
	/* 设置悬停背景颜色 */
}

/* 确保在折叠状态下弹出菜单正确显示 */
.el-menu--collapse .el-menu--popup {
	left: 100%;
	top: 0;
	position: absolute;
	z-index: 1000;
}

/* 确保子菜单项在折叠状态下可见 */
.el-menu--collapse .el-menu-item span {
	display: inline-block;
}
</style>

<style>
.submenu-title {
	display: block !important;
	z-index: 10 !important;
	padding-right: 10px;
}

.menu-wrapper {
	height: 100%;
	/* overflow: hidden; */
}

.slide-enter-active,
.slide-leave-active {
	transition: max-width 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
	max-width: 0;
}

.slide-enter-to,
.slide-leave-from {
	max-width: 200px;
	/* 设置为你菜单的实际宽度 */
}
</style>